// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.4_@rspack+core@1.7.11_@swc+helpers@0.5.5__webpack@5.104.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.4_@rspack+core@1.7.11_@swc+helpers@0.5.5__webpack@5.104.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --form-input-bg: rgba(22, 19, 28, 0.03);
}

.Toastify__toast-container {
  width: 440px;
  padding: 0;
  z-index: 1200;
}

/* .MuiPopover-root {
  z-index: 1300 !important;
} */

html.modal-is-open {
  overflow: hidden;
}

body {
  overflow-y: auto !important;
  scrollbar-width: none !important; /* Firefox */
  -ms-overflow-style: none !important; /* Internet Explorer and Edge */
}

body::-webkit-scrollbar {
  display: none !important; /* Chrome, Safari, and Opera */
  width: 0 !important;
}

.katex {
  white-space: normal !important;
  text-align: left !important;
}

.katex-display {
  margin: 0 !important;
}

.recharts-surface {
  overflow: inherit;
}

.Toastify__toast-container--top-right {
  right: 0;
  top: 80px;
}

.Toastify__toast--default {
  background: transparent !important;
}

/* Note: Hide arrows on number input */
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.MuiDataGrid-root
  .MuiDataGrid-columnHeaders
  .MuiDataGrid-scrollbarFiller.MuiDataGrid-scrollbarFiller {
  background: transparent;
  border-bottom: transparent !important;
}

.MuiDataGrid-scrollbarFiller.MuiDataGrid-scrollbarFiller--borderTop {
  border-top: transparent !important;
}

/*
requested by client 51tocarbonzero
https://www.notion.so/Dynamic-styling-based-on-host-2af39fe2219d80939407c20c09b77047
*/

.button.is-info:not(.is-light, .is-outlined) {
  background-color: rgb(14, 77, 103);
  color: hsl(0, 0%, 100%);
}
.button.is-info:not(.is-light, .is-outlined):hover {
  background-color: #187ea9;
}
.button.is-info.is-outlined:hover {
  background-color: #187ea9;
}

/*end*/
`, "",{"version":3,"sources":["webpack://./src/styles/globalOverrides.css"],"names":[],"mappings":"AAAA;EACE,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,aAAa;AACf;;AAEA;;GAEG;;AAEH;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC,EAAE,YAAY;EAC9C,mCAAmC,EAAE,+BAA+B;AACtE;;AAEA;EACE,wBAAwB,EAAE,8BAA8B;EACxD,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kCAAkC;AACpC;;AAEA,sCAAsC;AACtC,gCAAgC;AAChC;;EAEE,wBAAwB;EACxB,SAAS;AACX;AACA,YAAY;AACZ;EACE,0BAA0B;AAC5B;;AAEA;;;EAGE,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;;CAGC;;AAED;EACE,kCAAkC;EAClC,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA,MAAM","sourcesContent":[":root {\n  --form-input-bg: rgba(22, 19, 28, 0.03);\n}\n\n.Toastify__toast-container {\n  width: 440px;\n  padding: 0;\n  z-index: 1200;\n}\n\n/* .MuiPopover-root {\n  z-index: 1300 !important;\n} */\n\nhtml.modal-is-open {\n  overflow: hidden;\n}\n\nbody {\n  overflow-y: auto !important;\n  scrollbar-width: none !important; /* Firefox */\n  -ms-overflow-style: none !important; /* Internet Explorer and Edge */\n}\n\nbody::-webkit-scrollbar {\n  display: none !important; /* Chrome, Safari, and Opera */\n  width: 0 !important;\n}\n\n.katex {\n  white-space: normal !important;\n  text-align: left !important;\n}\n\n.katex-display {\n  margin: 0 !important;\n}\n\n.recharts-surface {\n  overflow: inherit;\n}\n\n.Toastify__toast-container--top-right {\n  right: 0;\n  top: 80px;\n}\n\n.Toastify__toast--default {\n  background: transparent !important;\n}\n\n/* Note: Hide arrows on number input */\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n/* Firefox */\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n.MuiDataGrid-root\n  .MuiDataGrid-columnHeaders\n  .MuiDataGrid-scrollbarFiller.MuiDataGrid-scrollbarFiller {\n  background: transparent;\n  border-bottom: transparent !important;\n}\n\n.MuiDataGrid-scrollbarFiller.MuiDataGrid-scrollbarFiller--borderTop {\n  border-top: transparent !important;\n}\n\n/*\nrequested by client 51tocarbonzero\nhttps://www.notion.so/Dynamic-styling-based-on-host-2af39fe2219d80939407c20c09b77047\n*/\n\n.button.is-info:not(.is-light, .is-outlined) {\n  background-color: rgb(14, 77, 103);\n  color: hsl(0, 0%, 100%);\n}\n.button.is-info:not(.is-light, .is-outlined):hover {\n  background-color: #187ea9;\n}\n.button.is-info.is-outlined:hover {\n  background-color: #187ea9;\n}\n\n/*end*/\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
